import { Flex, Select } from "antd";
import { FC } from "react";
import { Option } from "tm-shared/types";

import { BaseModal } from "@/components/BaseModal";
import { SecondaryText } from "@/components/Typography/Styled";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { CameraSource, setCameraSource } from "@/store/slices/config";

type CameraModeModalProps = {
    open: boolean;
    onClose: () => void;
};

const cameraOptions: Option<CameraSource>[] = [
    { value: "app", label: "Нова камера (рекомендовано)" },
    { value: "native", label: "Стара камера (сумісність)" },
];

export const CameraModeModal: FC<CameraModeModalProps> = ({
    open,
    onClose,
}) => {
    const dispatch = useAppDispatch();

    const { cameraSource } = useAppSelector((state) => state.config);

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            hideConfirm
            cancelText="Закрити"
            title={"Режим камери для зйомки фото"}
            maskClosable={true}
        >
            <Flex vertical gap={6}>
                <SecondaryText>
                    Оберіть режим, якщо є проблеми зі стартом камери або якістю
                    зображення.
                </SecondaryText>
            </Flex>

            <Select<CameraSource>
                size="large"
                style={{ width: "100%" }}
                value={cameraSource}
                options={cameraOptions}
                onChange={(value) => {
                    dispatch(setCameraSource(value));
                }}
            />
        </BaseModal>
    );
};
